import { IKogIcon } from '@/main/@types/interfaceIcons'
import React from 'react'

export function PreQuoteIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 182.000000 164.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,164.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path d="M775 1620 c-308 -49 -559 -270 -652 -575 -26 -86 -26 -344 0 -430 68
          -223 218 -401 422 -500 125 -62 203 -79 355 -78 105 0 139 4 213 27 115 34
          188 72 278 144 128 101 229 257 275 422 14 48 18 100 18 200 0 152 -13 215
          -70 340 -69 149 -212 298 -355 370 -136 69 -339 102 -484 80z m330 -70 c130
          -41 222 -96 315 -190 97 -97 150 -180 186 -295 51 -159 51 -311 0 -470 -36
          -115 -89 -198 -186 -295 -135 -136 -293 -207 -485 -217 -220 -12 -420 64 -574
          218 -92 93 -162 216 -198 349 -24 88 -24 272 0 360 20 76 73 192 115 252 102
          148 274 261 462 303 94 21 274 14 365 -15z"
        />
        <path d="M877 1223 c-12 -11 -8 -531 3 -538 6 -4 17 -1 25 5 12 10 15 56 15
          264 0 183 -3 255 -12 264 -14 14 -22 15 -31 5z"
        />
        <path d="M868 569 c-25 -14 -24 -65 1 -79 11 -5 24 -10 30 -10 16 0 41 30 41
          50 0 21 -25 50 -43 50 -7 0 -20 -5 -29 -11z"
        />
      </g>
    </svg>
  )
}